import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbandonDossierSheetComponent } from '@sc/ui-components';
import { DossierAbandonOutputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-dossier-abandon-dialog',
  styleUrls: ['./dossier-abandon-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AbandonDossierSheetComponent],
  template: `
    <sc-abandon-dossier-sheet
      (abandonCommentResult)="onAbandonCommentResult($event)"
    ></sc-abandon-dossier-sheet>
  `,
})
export class DossierAbandonDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<
      DossierAbandonDialogComponent,
      DossierAbandonOutputData
    >
  ) {}

  onAbandonCommentResult($event) {
    this.dialogRef.close($event);
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    this.onAbandonCommentResult({ type: 'cancel' });
  }
}
